<div class="form-wrapper">
    <div class="card-form">

        <!-- Header -->
        <div class="form-header">
            <div class="form-badge">
                <i class="bi bi-person-plus-fill"></i>
            </div>
            <h4 class="form-title">Crea tu cuenta</h4>
            <p class="form-subtitle">Solo el nombre de tu empresa — el resto lo configuras luego dentro de la app.</p>
        </div>

        <!-- 👇 Envuelve todo en el form -->
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">

            <!-- Nombre de la empresa -->
            <div class="mb-3">
                <label class="form-label">Nombre de tu empresa</label>
                <div class="input-wrapper">
                    <i class="bi bi-building input-icon"></i>
                    <input type="text" class="form-control custom-input" placeholder="Ej: Innotech S.A.S"
                        formControlName="companyName">
                </div>
                <div class="error-msg"
                    *ngIf="registerForm.get('companyName')?.touched && registerForm.get('companyName')?.invalid">
                    El nombre de la empresa es obligatorio
                </div>
            </div>

            <!-- Tabs -->
            <div class="tabs-container mb-3">
                <button type="button" class="tab-btn" [class.active]="activeTab === 'social'"
                    (click)="setTab('social')">
                    <i class="bi bi-share-fill"></i>
                    Cuenta de correo
                </button>
                <button type="button" class="tab-btn" [class.active]="activeTab === 'email'" (click)="setTab('email')">
                    <i class="bi bi-envelope-fill"></i>
                    Correo y contraseña
                </button>
            </div>

            <!-- Contenido: Redes sociales -->
            <div *ngIf="activeTab === 'social'" class="tab-content">
                <div class="row g-2 mb-3">
                    <div class="col-6">
                        <div class="provider-card google" (click)="registerWithProveedorEmail('google')">
                            <svg class="provider-icon" width="26" height="26" viewBox="0 0 24 24">
                                <path fill="#4285F4"
                                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                                <path fill="#34A853"
                                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                                <path fill="#FBBC05"
                                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                                <path fill="#EA4335"
                                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                            </svg>
                            <div class="provider-title">Continuar con <strong>Google</strong></div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="provider-card microsoft" (click)="registerWithProveedorEmail('microsoft')">
                            <svg class="provider-icon" width="26" height="26" viewBox="0 0 24 24">
                                <path fill="#F35325" d="M2 2h10v10H2z" />
                                <path fill="#81BC06" d="M12 2h10v10H12z" />
                                <path fill="#05A6F0" d="M2 12h10v10H2z" />
                                <path fill="#FFBA08" d="M12 12h10v10H12z" />
                            </svg>
                            <div class="provider-title">Continuar con <strong>Microsoft</strong></div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-4">
                    <button type="button" class="btn-back" routerLink="/index">
                        <i class="bi bi-arrow-left"></i>
                        Atrás
                    </button>

                </div>
            </div>

            <!-- Contenido: Correo y contraseña -->
            <div *ngIf="activeTab === 'email'" class="tab-content">
                <div class="mb-3">
                    <label class="form-label">Nombre completo</label>
                    <div class="input-wrapper">
                        <i class="bi bi-person-fill input-icon"></i>
                        <input type="text" class="form-control custom-input" placeholder="Tu nombre"
                            formControlName="fullName">
                    </div>
                    <div class="error-msg"
                        *ngIf="registerForm.get('fullName')?.touched && registerForm.get('fullName')?.invalid">
                        El nombre es obligatorio
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">Correo</label>
                    <div class="input-wrapper">
                        <i class="bi bi-envelope-fill input-icon"></i>
                        <input type="email" class="form-control custom-input" placeholder="admin@dominio.com"
                            formControlName="email">
                    </div>
                    <div class="error-msg"
                        *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.invalid">
                        Ingresa un correo válido
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label">Contraseña</label>
                    <div class="input-wrapper">
                        <i class="bi bi-lock-fill input-icon"></i>
                        <input [type]="showPassword ? 'text' : 'password'" class="form-control custom-input"
                            placeholder="**********" formControlName="password">
                        <button type="button" class="toggle-password" (click)="togglePassword()"
                            [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                            <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
                        </button>
                    </div>
                    <div class="error-msg"
                        *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.invalid">
                        Mínimo 6 caracteres
                    </div>
                </div>
                <!-- Footer -->
                <div class="d-flex justify-content-between align-items-center mt-4">
                    <button type="button" class="btn-back" routerLink="/index">
                        <i class="bi bi-arrow-left"></i>
                        Atrás
                    </button>
                    <button type="submit" class="btn-primary-custom">
                        Crear cuenta
                        <i class="bi bi-arrow-right"></i>
                    </button>
                </div>
            </div>




        </form>
    </div>
</div>